import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, firstValueFrom, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../_models/user.model';
import { RestRoutes } from '../_config/rest-routes.config';
import { LoginRequest } from '../_models/LoginRequest.model';
import { StorageService } from './storage.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LanguageManagerService } from './languagemanager.service';
import { LoginSSORequest } from '../_models/LoginSSORequest.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public configObservable = new Subject<User>();
  public authError$ = new Subject<any>();

  isLoggedIn: boolean = false;
  userID: string;
  commerceList: string[] = [];
  // tokenData: any = {
  //   id: '',
  //   name: '',
  //   profileID: '',
  //   office: '',
  //   enrollment: '',
  //   commerce: '',
  //   contactGroupId: '',
  // };

  constructor(
    private http: HttpClient,
    private _storageService: StorageService,
    private jwtHelper: JwtHelperService,
    public langService: LanguageManagerService,
  ) {}

  async login(UserName: string, Password: string) {
    //let urlLogin: string = `${RestRoutes.AUTH_LOCAL}`;
    let urlLogin: string = `${environment.urlWS}${RestRoutes.AUTH}/login`;
    //var loginRequest = new LoginRequest();
    // loginRequest.UserName=UserName;
    // loginRequest.Password = Password;
    // // console.log(loginRequest);
    var loginRequest = new LoginRequest();
    loginRequest.userName = UserName.trim();
    loginRequest.password = Password;
    //loginRequestUserConfigurator.userGuid = UserName;
    //loginRequestUserConfigurator.apiKey = Password;
    // console.log(loginRequest);
    await fetch(urlLogin, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify(loginRequest),
    })
      //.then(Helper.handleErrors)
      //.then((response) => response.json())
      //.then(response => {return response.json()})
      .then(async (response) => {
        let responseBody: any;
        let errorMessage = '';
        switch (response.status) {
          case 200: // do something here
            responseBody = await response.json();
            this.LoginSuccessful(responseBody);
            break;
          case 409: // do something here
            responseBody = await response.json();
            this.authError$.next('');
            break;
          case 500: // do something here
            responseBody = await response.json();
            if (responseBody.hasOwnProperty('detail')) {
              errorMessage = responseBody['detail'];
            }
            errorMessage = this.langService
              .translate('@@CMP.Error_Server')
              .replace('{0}', errorMessage);
            this.authError$.next(errorMessage);
            break;
          default:
            errorMessage = this.langService
              .translate('@@CMP.Error_Undefined')
              .replace('{0}', response.status.toString());
            this.authError$.next(errorMessage);
            break;
        }
      })
      // .then(async (result) => {
      //   // console.log(result);
      //   this.LoginSuccessful(result);
      // })
      .catch((error) => {
        console.log(JSON.stringify(error));
      });
  }

  async loginSSO(sessionId: string) {
    let urlLogin: string = `${environment.urlWS}${RestRoutes.AUTHv3}/sso/token`;

    var loginRequest = new LoginSSORequest();
    loginRequest.sessionId = sessionId;
    await fetch(urlLogin, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify(loginRequest),
    })
      .then(async (response) => {
        let responseBody: any;
        let errorMessage = '';

        let base64Error = '';
        if (response.status !== 200) {
          const payload = {
            statusCode: response.status,
            statusMessage: response.statusText ?? '',
            url: response.url,
          };

          base64Error = this.toBase64Utf8(JSON.stringify(payload));
        }

        switch (response.status) {
          case 200: // do something here
            responseBody = await response.json();
            this.LoginSuccessful(responseBody);
            break;
          case 409: // do something here
            responseBody = await response.json();
            this.authError$.next('');
            break;
          case 500: // do something here
            responseBody = await response.json();
            if (responseBody.hasOwnProperty('detail')) {
              errorMessage = responseBody['detail'];
            }
            errorMessage = this.langService
              .translate('@@CMP.Error_Server')
              .replace('{0}', errorMessage);
            this.authError$.next(errorMessage);
            break;
          default:
            // errorMessage = this.langService
            //   .translate('@@CMP.Error_Undefined')
            //   .replace('{0}', response.status.toString());
            this.authError$.next(base64Error);
            break;
        }
      })
      .catch((error) => {
        console.log(JSON.stringify(error));
      });
  }

  private toBase64Utf8(input: string): string {
    const bytes = new TextEncoder().encode(input);
    let binary = '';
    for (const b of bytes) binary += String.fromCharCode(b);
    return btoa(binary);
  }

  async validate(): Promise<object> {
    let url: string = `${environment.urlWS}${RestRoutes.AUTH}/validateAuthJWT`;
    return firstValueFrom(this.http.post(url, httpOptions));
  }

  async getUserInfo(): Promise<User> {
    let urlUser: string = `${environment.urlWS}${RestRoutes.USER}`;
    return firstValueFrom(this.http.get<User>(urlUser, httpOptions));
  }

  async UpdateEnrolment(userID: any): Promise<any> {
    let urlUpdate: string = `${environment.urlWS}${RestRoutes.USERS}/${userID}/enrolled`;
    try {
      const response = await lastValueFrom(
        this.http.put<any>(urlUpdate, {}, httpOptions),
      );
      this.updateEnrollmentData(response);
      return true;
    } catch (error) {
      console.error('Error in UpdateEnrolment', error);
      return false;
    }
  }

  private LoginSuccessful(response: any) {
    let tokenData = this.decodeToken(response.token);
    this.setTokenData(tokenData);
    this.saveToken(response.token);
    let username = response.userName;
    if (!response.userName) {
      username = tokenData.name;
    }
    this.saveUserName(username);
    this._storageService.clearPageCache();
    var userInfo = new User();
    userInfo.user = username;
    this._storageService.saveUser(userInfo);
    this.configObservable.next(userInfo);
  }

  private updateEnrollmentData(response: any) {
    this.LoginSuccessful(response);
    //Decodificamos y guardamos los datos del token
    const decodedToken = this.decodeToken(response.token);
    this.setTokenData(decodedToken);
  }

  setLoggedIn() {
    this.isLoggedIn = true;
  }

  getLoggedIn() {
    return this.isLoggedIn;
  }

  logOut() {
    this._storageService.clean();
    this.configObservable.next(null);
  }

  public saveUserName(username: any): void {
    this._storageService.saveUserName(username);
  }

  public saveToken(token: any): void {
    this._storageService.saveToken(token);
  }

  public getToken(): string {
    return this._storageService.getToken();
  }

  public clearToken(): void {
    this._storageService.clearToken();
  }

  setTokenData(tokenData: any): void {
    this._storageService.setTokenData(tokenData);
  }

  getTokenData(): any {
    return this._storageService.getTokenData();
  }

  clearTokenData(): void {
    this._storageService.clearTokenData();
  }

  decodeToken(token: any) {
    const decodedToken = this.jwtHelper.decodeToken(token);
    let tokenData = {
      id: decodedToken.id || '',
      name: decodedToken.name || '',
      profileID: decodedToken.ProfileID || '',
      office: decodedToken.Office || '',
      enrollment: decodedToken.Enrollment || '',
      commerce: decodedToken.Commerce || '',
      contactGroupId: decodedToken.ContactGroupsIds || '',
    };

    return tokenData;
  }
}
